// StepTwoRecurringOption.jsx
import React, { useState, useMemo } from 'react';
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa';
import './StepTwoRecurringOption.css';

function StepTwoRecurringOption({
  quantity,
  onSetMakeRecurring,
  onBack,
  onContinue,
}) {
  const [allRecurring, setAllRecurring] = useState(false);

  const nextPaymentDate = useMemo(() => {
    const now = new Date();
    now.setDate(now.getDate() + 30);
    return now.toLocaleDateString();
  }, []);

  const promptMessage =
    quantity === 1
      ? 'You have 1 monthly pass selected. Would you like it to renew automatically?'
      : `You have ${quantity} monthly passes selected. Would you like them to renew automatically?`;

  return (
    <div className="StepTwoContainer">
      <h3>Recurring Option</h3>
      <p>{promptMessage}</p>

      <div className="StepTwoCheckboxAll">
        <label>
          <input
            type="checkbox"
            checked={allRecurring}
            onChange={(e) => setAllRecurring(e.target.checked)}
            style={{ marginRight: '0.5em' }}
          />
          {allRecurring
            ? 'Yes, renew automatically.'
            : 'Do not renew automatically.'}
        </label>
      </div>

      {allRecurring && (
        <div className="recurring-info-box">
          <p><strong>Important:</strong> To set up recurring payments, you'll need to save your card information. This card will be automatically charged each month for your membership renewal.</p>
          <p>Next payment date: <strong>{nextPaymentDate}</strong></p>
        </div>
      )}

      <div style={{ marginTop: '1.5em' }}>
        <button onClick={onBack} className="StepTwoBackButton">
          <FaArrowAltCircleLeft className="StepTwoBackButtonIcon" />
          Back
        </button>
        <button
          onClick={() => {
            onSetMakeRecurring(allRecurring);
            onContinue();
          }}
          className="StepTwoContinueButton"
        >
          Continue to Checkout
          <FaArrowAltCircleRight className="StepTwoContinueButtonIcon" />
        </button>
      </div>
    </div>
  );
}

export default StepTwoRecurringOption;
